module.exports = __webpack_public_path__ + "product-view-sequence-listing.component.html";


//////////////////
// WEBPACK FOOTER
// ./vendor/sections/product/views/sequence/product-view-sequence-listing.component.html
// module id = 922
// module chunks = 0